import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import api from "../lib/api";
import { AlertTriangle, Info, XOctagon } from "lucide-react";

const SEVERITY_STYLES = {
  info: { bg: "bg-[hsl(214_100%_35%)]/10", text: "text-[hsl(214_100%_35%)]", border: "border-[hsl(214_100%_35%)]/30", icon: Info },
  warning: { bg: "bg-[hsl(38_92%_30%)]/10", text: "text-[hsl(38_92%_30%)]", border: "border-[hsl(38_92%_30%)]/40", icon: AlertTriangle },
  critical: { bg: "bg-[hsl(0_75%_45%)]/10", text: "text-[hsl(0_75%_45%)]", border: "border-[hsl(0_75%_45%)]/40", icon: XOctagon },
};

export default function Layout({ title, subtitle, actions, children }) {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    api.get("/public/ui-settings")
      .then((r) => {
        if (r.data.maintenance_banner_enabled && r.data.maintenance_banner_message) {
          setBanner({
            message: r.data.maintenance_banner_message,
            severity: r.data.maintenance_banner_severity || "info",
          });
        } else {
          setBanner(null);
        }
      })
      .catch(() => setBanner(null));
  }, []);

  const s = banner ? (SEVERITY_STYLES[banner.severity] || SEVERITY_STYLES.info) : null;
  const Icon = s?.icon;

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <div className="pl-64">
        {banner && (
          <div className={`${s.bg} ${s.text} ${s.border} border-b px-8 py-2 text-xs font-medium flex items-center gap-2`} data-testid="maintenance-banner">
            <Icon className="w-3.5 h-3.5" strokeWidth={2} />
            <span>{banner.message}</span>
          </div>
        )}
        <Topbar title={title} subtitle={subtitle} actions={actions} />
        <main className="px-8 py-6 max-w-[1600px] mx-auto animate-fade-in-up">{children}</main>
      </div>
    </div>
  );
}
